import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface Props {
  permissions?: string[];
}

const PrivateRoute: React.FC<Props> = ({ permissions:p }) => {
  const { user, loading, hasPermissions } = useAuth();

  if (loading) {
    return <></>;
  }

  if (p && p.length > 0 && !hasPermissions(['Administrator'].concat(p))) {
    return <Navigate to="/dashboard" replace />;
  }

  return user && !user.is_anonymous ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;
